import type { HelpFile } from '../../types/help'
import { CertificationPolicyDetailTestIds } from '../../../testids/CertificationPolicyDetailTestIds'

export const certificationPolicyDetailHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [CertificationPolicyDetailTestIds.certificationPolicyDetailPage]:
      'Schreibgeschützte Zusammenfassung dieser Zertifizierungsrichtlinie. Über die Bearbeiten-Schaltflächen je Abschnitt im Assistenten ändern.',
    [CertificationPolicyDetailTestIds.badgeCampaignCount]:
      'Anzahl der bereits aus dieser Richtlinie erzeugten Zertifizierungskampagnen.',
    [CertificationPolicyDetailTestIds.btnCreateCampaign]:
      'Erstellt eine neue Zertifizierungskampagne aus dieser Richtlinie im Status „Vorbereitung".',
    [CertificationPolicyDetailTestIds.btnDelete]:
      'Löscht diese Richtlinie endgültig. Bereits erzeugte Kampagnen sind nicht betroffen.',
    [CertificationPolicyDetailTestIds.btnEditBasics]:
      'Öffnet den Abschnitt „Grundlagen" des Richtlinien-Assistenten zum Bearbeiten von Name, Beschreibung, Priorität und Zeitraum.',
    [CertificationPolicyDetailTestIds.btnEditScope]:
      'Öffnet den Schritt „Geltungsbereich" des Assistenten zum Bearbeiten der erfassten Zugangszuweisungen.',
    [CertificationPolicyDetailTestIds.btnEditReviewSettings]:
      'Öffnet den Schritt „Prüfungseinstellungen", um Prüfertyp, Häufigkeit und Nicht-Antwort-Maßnahme zu ändern.',
    [CertificationPolicyDetailTestIds.sectionBasics]:
      'Grunddaten der Richtlinie — Name, Beschreibung, Priorität und Gültigkeitszeitraum.',
    [CertificationPolicyDetailTestIds.sectionScope]:
      'Legt fest, welche Zugangszuweisungen von dieser Richtlinie zertifiziert werden — als strukturierte Bedingungen oder CEL-Ausdruck.',
    [CertificationPolicyDetailTestIds.sectionReviewSettings]:
      'Steuert den Prüfungszyklus — wer prüft, wie oft, Nachfrist und was passiert, wenn ein Prüfer nicht antwortet.',
    [CertificationPolicyDetailTestIds.sectionBasicsTitle]: null,
    [CertificationPolicyDetailTestIds.sectionScopeTitle]: null,
    [CertificationPolicyDetailTestIds.sectionReviewSettingsTitle]: null,
    [CertificationPolicyDetailTestIds.infoDefaultPolicy]: null,
    [CertificationPolicyDetailTestIds.infoOpenCampaignWarning]: null,
    [CertificationPolicyDetailTestIds.policyOwner]: null,
  },
}
